import * as React from 'react'
import { SelectTagOption } from './SelectTagOption'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const SelectTagOptionExamples = () => {
  return (
    <div className="SelectTagOptionExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <SelectTagOption id="123" type="user" />
      </Provider>
    </div>
  )
}
